import vueConfig from '../../config/vueConfig'

var adminPath = vueConfig.adminUrl;
export default {
    adminPages: [
        {path: adminPath + "/workOrder", component: () => import("./workOrder.vue")},
    ],
    pages: []
}
